import { gql } from 'apollo-angular';
import { learningResourceArticleMinimal } from './learning-resource-article.minimal';
import { learningResourceFileMinimal } from './learning-resource-file.minimal';
import { learningResourceLinkMinimal } from './learning-resource-link.minimal';
import { learningResourceMicroLearningMinimal } from './learning-resource-micro-learning.minimal';
import { learningResourceSetMinimal } from './learning-resource-set.minimal';

export const learningResourceSetWithItemsFragment = gql`
  fragment LearningResourceSetWithItems on LearningResourceSet {
    ...LearningResourceSetMinimal
    learningResourceItems {
      edges {
        order
        alertAfterDays
        alertExpiresAfterDays
        alertedRoleTypes
        alertSendMail
        node {
          ... on LearningResourceArticle {
            ...LearningResourceArticleMinimal
          }

          ... on LearningResourceMicroLearning {
            ...LearningResourceMicroLearningMinimal
          }

          ... on LearningResourceLink {
            ...LearningResourceLinkMinimal
          }

          ... on LearningResourceFile {
            ...LearningResourceFileMinimal
          }
        }
      }
    }
  }
  ${learningResourceSetMinimal}
  ${learningResourceArticleMinimal}
  ${learningResourceLinkMinimal}
  ${learningResourceFileMinimal}
  ${learningResourceMicroLearningMinimal}
`;
